<script>
export default {
  data () {
    return {
      statusesMap: {
        STATUS_IN_CART: {
          text: this.$t('statuses.STATUS_IN_CART'),
          color: 'is-light',
          size: '',
          sellerModeOnly: true
        },
        STATUS_WAITING_TO_ACCEPT: {
          text: this.$t('statuses.STATUS_WAITING_TO_ACCEPT'),
          color: 'is-light',
          size: ''
        },
        STATUS_ACCEPTED: {
          text: this.$t('statuses.STATUS_ACCEPTED'),
          color: 'is-light',
          size: ''
        },
        STATUS_ACCEPTED_SMS: {
          text: this.$t('statuses.STATUS_ACCEPTED_SMS'),
          color: 'is-light',
          size: ''
        },
        STATUS_ACCEPTED_EMAIL: {
          text: this.$t('statuses.STATUS_ACCEPTED_EMAIL'),
          color: 'is-light',
          size: ''
        },
        STATUS_CANCELED: {
          text: this.$t('statuses.STATUS_CANCELED'),
          color: 'is-light',
          size: ''
        },
        STATUS_CANCELED_SMS: {
          text: this.$t('statuses.STATUS_CANCELED_SMS'),
          color: 'is-light',
          size: ''
        },
        STATUS_CANCELED_EMAIL: {
          text: this.$t('statuses.STATUS_CANCELED_EMAIL'),
          color: 'is-light',
          size: ''
        },
        STATUS_LINK_EXPIRED: {
          text: this.$t('statuses.STATUS_LINK_EXPIRED'),
          color: 'is-light',
          size: ''
        },
        STATUS_PROFORMA_CREATED: {
          text: this.$t('statuses.STATUS_PROFORMA_CREATED'),
          color: 'is-light',
          size: '',
          sellerModeOnly: true
        },
        STATUS_INVOICE_CREATED: {
          text: this.$t('statuses.STATUS_INVOICE_CREATED'),
          color: 'is-light',
          size: '',
          sellerModeOnly: true
        },
        STATUS_EDITED_ADDRESS: {
          text: this.$t('statuses.STATUS_EDITED_ADDRESS'),
          color: 'is-light',
          size: '',
          sellerModeOnly: true
        },
        STATUS_CORRECTION_CREATED: {
          text: this.$t('statuses.STATUS_CORRECTION_CREATED'),
          color: 'is-light',
          size: '',
          sellerModeOnly: true
        },
        STATUS_WAYBILL_CREATED: {
          text: this.$t('statuses.STATUS_WAYBILL_CREATED'),
          color: 'is-light',
          size: ''
        },
        MOLLIE_OPEN: {
          text: this.$t('statuses.MOLLIE_OPEN'),
          color: 'is-warning',
          size: ''
        },
        MOLLIE_PENDING: {
          text: this.$t('statuses.MOLLIE_PENDING'),
          color: 'is-warning',
          size: ''
        },
        MOLLIE_FAILED: {
          text: this.$t('statuses.MOLLIE_FAILED'),
          color: 'is-danger',
          size: ''
        },
        MOLLIE_EXPIRED: {
          text: this.$t('statuses.MOLLIE_EXPIRED'),
          color: 'is-danger',
          size: ''
        },
        MOLLIE_CANCELED: {
          text: this.$t('statuses.MOLLIE_CANCELED'),
          color: 'is-danger',
          size: ''
        },
        MOLLIE_COMPLETED: {
          text: this.$t('statuses.MOLLIE_COMPLETED'),
          color: 'is-success',
          size: 'is-large'
        },
        MOLLIE_REFUNDS: {
          text: this.$t('statuses.MOLLIE_REFUNDS'),
          color: 'is-success',
          size: 'is-large'
        },
        MOLLIE_CHARGEBACKS: {
          text: this.$t('statuses.MOLLIE_CHARGEBACKS'),
          color: 'is-success',
          size: 'is-large'
        },
        MOLLIE_AUTHORIZED: {
          text: this.$t('statuses.MOLLIE_AUTHORIZED'),
          color: 'is-bulma',
          size: ''
        },
        PAYPAL_PENDING: {
          text: this.$t('statuses.PAYPAL_PENDING'),
          color: 'is-warning',
          size: ''
        },
        PAYPAL_APPROVED: {
          text: this.$t('statuses.PAYPAL_APPROVED'),
          color: 'is-success',
          size: 'is-large'
        },
        PAYPAL_COMPLETED: {
          text: this.$t('statuses.PAYPAL_COMPLETED'),
          color: 'is-success',
          size: 'is-large'
        },
        PAYPAL_CANCELED: {
          text: this.$t('statuses.PAYPAL_CANCELED'),
          color: 'is-danger',
          size: ''
        },
        PAYU_PENDING: {
          text: this.$t('statuses.PAYU_PENDING'),
          color: 'is-warning',
          size: ''
        },
        PAYU_COMPLETED: {
          text: this.$t('statuses.PAYU_COMPLETED'),
          color: 'is-success',
          size: 'is-large'
        },
        PAYU_CANCELED: {
          text: this.$t('statuses.PAYU_CANCELED'),
          color: 'is-danger',
          size: ''
        },
        PROGRESS: {
          text: this.$t('statuses.PAYMENT_PROGRESS'),
          color: 'is-warning',
          size: ''
        },
        COMPLETED: {
          text: this.$t('statuses.PAYMENT_COMPLETED'),
          color: 'is-success',
          size: 'is-large'
        },
        CANCELED: {
          text: this.$t('statuses.PAYMENT_CANCELED'),
          color: 'is-danger',
          size: ''
        },
        EXPIRED: {
          text: this.$t('statuses.PAYMENT_EXPIRED'),
          color: 'is-danger',
          size: ''
        },
        AUTHORIZED: {
          text: this.$t('statuses.PAYMENT_AUTHORIZED'),
          color: 'is-bulma',
          size: ''
        },
        USER_CHANGED_PAYMENT: {
          text: this.$t('statuses.USER_CHANGED_PAYMENT'),
          color: 'is-light',
          size: ''
        },
        STORE_CHANGED_PAYMENT: {
          text: this.$t('statuses.STORE_CHANGED_PAYMENT'),
          color: 'is-light',
          size: ''
        },
        MOLLIE_REFUND_OPEN: {
          text: this.$t('statuses.MOLLIE_REFUND_OPEN'),
          color: 'is-warning',
          size: ''
        },
        MOLLIE_REFUND_PENDING: {
          text: this.$t('statuses.MOLLIE_REFUND_PENDING'),
          color: 'is-warning',
          size: ''
        },
        MOLLIE_REFUND_FAILED: {
          text: this.$t('statuses.MOLLIE_REFUND_FAILED'),
          color: 'is-danger',
          size: ''
        },
        MOLLIE_REFUND_EXPIRED: {
          text: this.$t('statuses.MOLLIE_REFUND_EXPIRED'),
          color: 'is-danger',
          size: ''
        },
        MOLLIE_REFUND_CANCELED: {
          text: this.$t('statuses.MOLLIE_REFUND_CANCELED'),
          color: 'is-danger',
          size: ''
        },
        MOLLIE_REFUND_COMPLETED: {
          text: this.$t('statuses.MOLLIE_REFUND_COMPLETED'),
          color: 'is-success',
          size: 'is-large'
        },
        PAYPAL_REFUND_PENDING: {
          text: this.$t('statuses.PAYPAL_REFUND_PENDING'),
          color: 'is-warning',
          size: ''
        },
        PAYPAL_REFUND_APPROVED: {
          text: this.$t('statuses.PAYPAL_REFUND_APPROVED'),
          color: 'is-success',
          size: 'is-large'
        },
        PAYPAL_REFUND_COMPLETED: {
          text: this.$t('statuses.PAYPAL_REFUND_COMPLETED'),
          color: 'is-success',
          size: 'is-large'
        },
        PAYPAL_REFUND_CANCELED: {
          text: this.$t('statuses.PAYPAL_REFUND_CANCELED'),
          color: 'is-danger',
          size: ''
        },
        REFUND_PROGRESS: {
          text: this.$t('statuses.REFUND_PROGRESS'),
          color: 'is-warning',
          size: ''
        },
        REFUND_COMPLETED: {
          text: this.$t('statuses.REFUND_COMPLETED'),
          color: 'is-success',
          size: 'is-large'
        },
        REFUND_CANCELED: {
          text: this.$t('statuses.REFUND_CANCELED'),
          color: 'is-danger',
          size: ''
        },
        PAYU_REFUND_COMPLETED: {
          text: this.$t('statuses.PAYU_REFUND_COMPLETED'),
          color: 'is-success',
          size: 'is-large'
        },
        PAYU_REFUND_CANCELED: {
          text: this.$t('statuses.PAYU_REFUND_CANCELED'),
          color: 'is-danger',
          size: ''
        },
        STATUS_PAY_START: {
          text: this.$t('statuses.STATUS_PAY_START'),
          color: 'is-light',
          size: ''
        },
        STATUS_PAYBACK_START: {
          text: this.$t('statuses.STATUS_PAYBACK_START'),
          color: 'is-light',
          size: ''
        },
        STATUS_PAY_END: {
          text: this.$t('statuses.STATUS_PAY_END'),
          color: 'is-light',
          size: ''
        },
        STATUS_PAYBACK_END: {
          text: this.$t('statuses.STATUS_PAYBACK_END'),
          color: 'is-light',
          size: ''
        },
        // Dopłata
        NOT_COMPLETE: {
          text: this.$t('statuses.PAYMENT_NOT_COMPLETE'),
          color: 'is-success is-stripe',
          size: ''
        },
        // Płatność częściowa
        STATUS_ORDER_INCOMPLETED: {
          text: this.$t('statuses.STATUS_ORDER_INCOMPLETED'),
          color: 'is-warning is-stripe',
          size: ''
        },
        // Płatność częsciowa ale na produkcji
        STATUS_SURCHARGE_REQUIRE: {
          text: this.$t('statuses.STATUS_SURCHARGE_REQUIRE'),
          color: 'is-dark-orange',
          size: ''
        },
        // Zamówienie które po korekcie ma wartość 0 zł . Czyli całkowity zwrot zamówienia
        STATUS_REFUND_ALL: {
          text: this.$t('statuses.STATUS_REFUND_ALL'),
          color: 'is-danger is-stripe',
          size: ''
        },
        // Płatność zakończona
        STATUS_COMPLETED: {
          text: this.$t('statuses.STATUS_COMPLETED'),
          color: 'is-light',
          size: ''
        },
        // Kredyt kupiecki
        PAID_USING_TRADE_CREDIT: {
          text: this.$t('statuses.PAID_USING_TRADE_CREDIT'),
          color: 'is-light',
          size: ''
        },
        STATUS_COMPLETED_TC: {
          text: this.$t('statuses.STATUS_COMPLETED_TC'),
          color: 'is-light',
          size: ''
        },
        TRADE_CREDIT_UNPAID: {
          text: this.$t('statuses.TRADE_CREDIT_UNPAID'),
          color: 'is-light',
          size: ''
        },
        TRADE_CREDIT_PAID: {
          text: this.$t('statuses.TRADE_CREDIT_PAID'),
          color: 'is-light',
          size: ''
        }
      }
    }
  }
}
</script>
